import React from "react";
// import { ProductInfoEdit } from "../../../contents/htmlContent";
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';
import { Row, Col, FormGroup, Label } from "reactstrap";
import { Field } from "formik";
import moment from "moment";
import Title from "../title";
import { ProductInfoEdit } from "../../contents/htmlContent";


export const InventorySection = ({
  errors,
  touched,
  values,
  setFieldValue,
  edit
}) => {


  return (
    <>


      <div className="info-product-title mt-4 ">
        <Title title={ProductInfoEdit.inventory} />
      </div>
      <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y" style={{
        backgroundColor: "#F5F7F8"
      }}>

        <div className="info trainer-info pl-1">
          <Row>
            <Col md={3}>
              <FormGroup className="custom-inputs ">
                <Field
                  type="number"
                  name="stock"
                  id="stock"
                  placeholder={ProductInfoEdit.stockPlaceHolder}
                  className={`form-control ${errors?.stock &&
                    touched?.stock &&
                    "is-invalid"}`}
                />
                {errors?.stock && touched.stock ? (
                  <div className="invalid-feedback">{`${errors?.stock}`}</div>
                ) : null}
                <Label for="name" style={{ backgroundColor: "#F5F7F8" }}>
                  {ProductInfoEdit.stock}
                </Label>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup className="custom-inputs ">
                <Field
                  type="text"
                  name="measureOfPurchase"
                  id="measureOfPurchase"
                  maxLength={50}
                  placeholder={"Measure of Purchase"}
                  className={`form-control ${errors.measureOfPurchase &&

                    "is-invalid"}`}
                />
                {errors.measureOfPurchase ? (
                  <div className="invalid-feedback">{`${errors.measureOfPurchase}`}</div>
                ) : null}
                <Label for="name" className="" style={{ backgroundColor: "#F5F7F8" }}>
                  {"Measure of Purchase"}
                </Label>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup className="custom-inputs ">
                <Field
                  type="number"
                  name="purchasedPrice"
                  id="purchasedPrice"
                  placeholder={"Purchase Price"}
                  className={`form-control`}
                />
                <Label for="name" style={{ backgroundColor: "#F5F7F8" }}>
                  {`Purchase Price / per ${values.measureOfPurchase}`}
                </Label>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup className="custom-inputs ">
                <Field
                  type="number"
                  name="cost"
                  value={values.stock * values.purchasedPrice}
                  maxLength={50}
                  disabled={true}
                  placeholder={ProductInfoEdit.costPlaceHolder}
                  className={`form-control`}
                />

                <Label for="name" style={{ backgroundColor: "#F5F7F8" }}>
                  {ProductInfoEdit.cost}
                </Label>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup className="custom-inputs ">
                <Field
                  type="number"
                  name="minInStock"
                  id="minInStock"
                  disabled={edit}
                  placeholder={"Min Quantity"}
                  className={`form-control ${errors.minInStock &&

                    "is-invalid"}`}
                />
                <Label for="name" style={{ backgroundColor: "#F5F7F8" }}>
                  {"Min in Stock"}
                </Label>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup className="custom-inputs ">
                <Field
                  type="text"
                  name="measureOfUnit"
                  id="measureOfUnit"
                  maxLength={50}
                  placeholder={"Measure of Unit"}
                  className={`form-control ${errors.measureOfUnit &&
                    "is-invalid"}`}
                />
                {errors.measureOfUnit ? (
                  <div className="invalid-feedback">{`${errors.measureOfUnit}`}</div>
                ) : null}
                <Label for="name" className="" style={{ backgroundColor: "#F5F7F8" }}>
                  {"MOU"}
                </Label>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup className="custom-inputs ">
                <DatePicker
                  colorPrimary="#7b00a3"
                  calendarPopperPosition={"left"}
                  onChange={(date) => {
                    console.log({ date })
                    const formatString = 'DD/M/YYYY';
                    let fomatDate = `${date.day}/${date.month.length == 1 ? `0 ${date.month}` : date.month}/${date.year}`
                    console.log({ fomatDate })
                    const parsedDate = moment(fomatDate, formatString);
                    if (date) setFieldValue("expiryDate", parsedDate);
                  }}
                  renderInput={({ ref }) => (
                    <>
                      <input
                        // readOnly
                        ref={ref} // necessary
                        placeholder="Expiry Date"
                        value={values.expiryDate?._i ? values.expiryDate._i : typeof (values.expiryDate) == "number" ? moment(values.expiryDate).format('DD/MM/YY') : values.expiryDate}
                        className={`form-control`}

                      />
                      <Label style={{ backgroundColor: "#F5F7F8" }}>{ProductInfoEdit.expiryDate}</Label>

                    </>

                  )}
                />
                {errors.expiryDate && touched.expiryDate ? (
                  <div className="invalid-feedback">{`${errors.expiryDate}`}</div>
                ) : null}
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup className="custom-inputs ">
                <Field
                  type="text"
                  name="supplier"
                  id="supplier"
                  maxLength={50}
                  placeholder={ProductInfoEdit.supplierPlaceHolder}
                  className={`form-control ${errors.supplier &&
                    touched.supplier &&
                    "is-invalid"}`}
                />
                {errors.supplier && touched.supplier ? (
                  <div className="invalid-feedback">{`${errors.supplier}`}</div>
                ) : null}
                <Label for="name" className="" style={{ backgroundColor: "#F5F7F8" }}>
                  {ProductInfoEdit.supplier}
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </div>

      </div>


    </>
  );
};
